var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "hidden-sm-and-up" },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "elevation-0 affiliations-table",
          attrs: { app: "", fixed: "" }
        },
        [
          _vm.filtersLayout
            ? _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    "justify-space-between": "",
                    "align-center": ""
                  }
                },
                [
                  _c("v-toolbar-title", { staticClass: "pl-4" }, [
                    _vm._v("Filtros")
                  ]),
                  _c(
                    "v-layout",
                    { attrs: { "justify-end": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", flat: "" },
                          on: { click: _vm.closeFilter }
                        },
                        [_c("v-icon", [_vm._v("icon-ic-close")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    "justify-space-between": "",
                    "align-center": ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "", flat: "", to: "/dashboard" } },
                    [_c("v-icon", [_vm._v("icon-ic-flecha-izquierda")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                  _c(
                    "v-layout",
                    { attrs: { "justify-end": "" } },
                    [
                      _c(
                        "v-btn",
                        { attrs: { icon: "", flat: "", to: "/dashboard" } },
                        [_c("v-icon", [_vm._v("icon-ic-close")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      ),
      _c(
        "v-content",
        [
          _c(
            "v-container",
            { staticClass: "pt-0", attrs: { fluid: "" } },
            [
              _c(
                "transition",
                { attrs: { name: "slide-x-transition" } },
                [_c("nuxt")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f75c22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f75c22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/affiliations.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-42f75c22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/affiliations.vue
// module chunks = 24